export default {
  labels: {
    title: 'Account detail',
    generalInformation: 'General information',
    chargesList: 'Charges list',
    reinvoicedAccounts: 'Reinvoiced accounts',
    accountSupports: 'Account supports',
    supportsAdministrator: 'Supports administrator',
    pendingAccountSupportFiles: 'Pending account support files',
    receivedAccountSupportFiles: 'Received account support files',
    pendingProductConfiguration: 'Unconfigured products. Review the ones marked in red on the list of charges',
    agreements: 'Agreement configuration',
    baseAccount: 'Base account',
    generateAccountTitle: 'Do you want to build account?',
    generateAccountSubtitle: 'This account has ({count}) missing documents, are you sure you want to proceed? This action cannot be undone or stopped.',
    generateAccountButton: 'Build account',
    reGenerateAccountButton: 'Re-build account',
    statusTooltip: {
      label: 'Last updated on {date} at {time} by {username}.',
      updatedBy: 'automated process'
    }
  },
	statuses: {
    PENDING: 'Pending',
    READY_TO_GENERATE: 'Ready to generate',
    GENERATED: 'Generated',
    VOIDED: 'Voided',
  },
  charges: {
    search: 'Search by charge ID',
    serviceType: 'Event type',
    from: 'From',
    to: 'To',
    notRequire: 'Not require',
    invoiceableFalse: 'not chargeable',
    completed: 'Completed',
    notCompleted: 'Not completed',
    serviceTypes: {
      hospitalization: 'Hospitalization',
      urgency: 'Urgency',
      outpatientCare: 'Outpatient care',
      procedure: 'Procedure',
      exam: 'Exam'
    },
    grid: {
      chargeId: 'Charge ID',
      eventNumber: 'Event',
      eventDate: 'Event date',
      invoiceAssigned: 'Invoiced',
      eventId: 'Event',
      serviceType: 'Event type',
      providerProductCode: 'Product code',
      patientName: 'Patient name',
      chargeDescription: 'Description',
      creationDateTime: 'Creation date',
      hasDocumentationComplete: 'Doc.',
      totalAmount: 'Amount ({currency})',
      hasAuditorComments: 'Comments',
      executorService: 'Specialty'
    }
  },
  finalizedAuditProcess:{
    completeAudit: "Complete Audit",
    uploadReconciliationRecord: "Upload Reconciliation Record",
    noAttachedFiles: "No attached files",
    uploadRestrictions: "Files in PDF, PNG, or JPEG format, maximum weight 20Mb",
    withoutFileUploads: "Continue without documentation"
  }
}
